export default {
  validation: {
    exporterRequired: "O campo Exportador é obrigatório",
    importerRequired: "O campo Importador é obrigatório",
    portOfOriginRequired: "O campo Porto de Origem é obrigatório",
    containerSizeNumber: "O campo Tamanho do Contêiner deve ser um número",
    containerCapacityNumber: "O campo Capacidade do Contêiner deve ser um número",
  },

  errors: {
    cannotBeBlank: "Este campo não pode estar em blanco",
    required: "Este campo é obrigatório",
    somethingWentWrong: "Algo deu errado!!!",
  },

}